import get from 'lodash/get'
import {createSelector} from 'reselect'
import sumBy from 'lodash/sumBy'

export const getToken = (state) => get(state, ['account', 'token', 'access_token']);
export const getCSRFToken = (state) => get(state, ['account', 'token', 'csrf_token']);
export const getClientId = (state) => get(state, ['account', 'token', 'client_id']);
export const getIsAuthenticated = (state) => get(state, ['account', 'details', 'authenticated']);
export const getAccountDetails = (state) => get(state, ['account', 'details']);
export const getAccountDetailsLoading = (state) => get(state, ['account', 'details', 'loading']);
export const getCartLoading = (state) => get(state, ['account', 'cart', 'loading']);
export const getWishlistItemCount = (state) => get(state, ['account', 'wishlist', 'total_items']);
export const getWishlistLoading = (state) => get(state, ['account', 'wishlist', 'loading']);
export const showAddToBag = (state) => false;

export const getCart = (state) => get(state, ['account', 'cart']);

export const getItemsAddingToCart = (state) => get(state, ['account', 'cart', 'itemsAddingToCart']);

export const getWishlistItems = (state) => get(state, ['account', 'wishlist', 'wishlistItems']);

export const getCartItemCount = createSelector(
    getCart,
    (cart) => {
        if(!cart) return 0;
        if(!cart.items) return cart.total_items;
        return sumBy(cart.items, i => i.quantity);
    }
)

export const getAccountInitials = createSelector(
    getAccountDetails,
    (details) => {
        if(!details || ! details.name) return null;
        var initials = details.name.match(/\b\w/g) || [];
        return ((initials.shift() || '') + (initials.shift() || '')).toUpperCase();
        //return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    }
)


// WEBPACK FOOTER //
// ./src/selectors/account.js